import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31fde7de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "expertise-section__predictor" }
const _hoisted_2 = { class: "expertise-section__predictor-title" }
const _hoisted_3 = { class: "expertise-section__predictor-manual-category-select" }
const _hoisted_4 = {
  slot: "checkbox-content",
  class: "checkbox__category-content"
}
const _hoisted_5 = { class: "checkbox__category-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_joy_tag = _resolveComponent("joy-tag")!
  const _component_joy_checkbox = _resolveComponent("joy-checkbox")!
  const _component_joy_link = _resolveComponent("joy-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$msg('profile.creation.predictor.wizard.details.predict.expertise.title')), 1),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.predictions, (prediction) => {
            return (_openBlock(), _createElementBlock("label", {
              key: prediction.categoryId,
              class: "m-checkbox select-category",
              "data-testid": "category-prediction"
            }, [
              _createVNode(_component_joy_checkbox, {
                class: _normalizeClass(["checkbox__category sc-joy-checkbox-h sc-joy-checkbox-s", {
                                'is-selected': _ctx.isToggled(prediction.categoryId),
                                'is-expertise': _ctx.isExpertise(prediction),
                            }]),
                checked: _ctx.isToggled(prediction.categoryId),
                name: prediction.categoryId,
                value: prediction.categoryId,
                onChange: _ctx.togglePrediction
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, _toDisplayString(prediction.categoryLabel), 1),
                    (_ctx.isExpertise(prediction))
                      ? (_openBlock(), _createBlock(_component_joy_tag, {
                          key: 0,
                          variant: "secondary",
                          size: "small",
                          class: "checkbox__category-expertise responsive-content"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$msg('profile.creation.predictor.wizard.v2.details.expertise.main')), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 2
              }, 1032, ["checked", "class", "name", "value", "onChange"])
            ]))
          }), 128))
        ])
      ])
    ]),
    (_ctx.displayCantFindMyExpertise)
      ? (_openBlock(), _createBlock(_component_joy_link, {
          key: 0,
          class: "expertise-section__not-found",
          onClick: _ctx.switchToManualSelection
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$msg('profile.creation.completion.wizard.categorization.category.find.help')), 1)
          ]),
          _: 1
        }, 8, ["onClick"]))
      : _createCommentVNode("", true)
  ]))
}